<template>
  <div>
    <div class="settings relative">
      <div class="btn-wrapper mb-10 mr-20 move-right">
        <router-link
          to="/admin/hrm/leave/create"
          class="btn btn-blue btn-full-radius inline-flex flex-v-end"
        >
          <span> + New Leave</span>
        </router-link>
      </div>
      <div class="grid-full flex flex-h-bet">
        <div class="flex table-tab">
          <router-link class="table-tab-item" to="/admin/hrm/leave/my-leave"
            >My Leave</router-link
          >
          <router-link class="table-tab-item" to="/admin/hrm/leave/approvals"
            >Approvals</router-link
          >
        </div>
        <router-link
          to="/admin/hrm/leave/settings"
          class="move-right grid-full"
        >
          <div class="settings-bg">
            <img src="/img/settings-b.svg" alt="settings" />
            <span>Settings</span>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="relative  adjust-height"
      v-if="approvalData && approvalData.length"
    >
      <div class="inner-table relative">
        <div :class="{ overlay: true, show: view }"></div>
        <div class="table-heading flex flex-v-center flex-h-bet">
          <div class="media-group flex">
            <p class="ml-10">Filter:</p>
            <el-select
              v-model="filterValue"
              placeholder="Select"
              class="filter-select"
            >
              <el-option
                v-for="item in filterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="relative">
            <img
              src="/img/search-icon.svg"
              alt="search team table"
              class="search-icon"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
            ></el-input>
          </div>
        </div>
        <LeaveApprovalsTable
          :data="approvalData"
          @handleViewDetails="handleViewDetails"
          @handleSelectionChange="handleSelectionChange"
        />
        <LeaveApprovalDetails :view="view" @toggleView="toggleView" />
      </div>
    </div>
    <NoDataToView v-else message="You are yet to create a leave" data="Leave" />
  </div>
</template>

<script>
import LeaveApprovalsTable from "../components/LeaveApprovalsTable";
import NoDataToView from "@/components/general/NoDataToView.vue";
import LeaveApprovalDetails from "../components/LeaveApprovalDetails";

export default {
  components: {
    LeaveApprovalsTable,
    LeaveApprovalDetails,
    NoDataToView,
  },
  data() {
    return {
      view: false,
      showForm: false,
      multipleSelection: [],
      filterValue: "",
      filterOptions: [
        {
          label: "Id",
          value: "id",
        },
        {
          label: "Team Name",
          value: "teamName",
        },
        {
          label: "No of members",
          value: "noOfMembers",
        },
        {
          label: "Date",
          value: "date",
        },
      ],
      approvalData: [
        {
          id: 1000,
          employeeName: "Ahmed",
          status: "Approved",
          leaveType: "Maternity",
          startDate: "10-12-2019",
          endDate: "10-12-2019",
          relief: "Nonso Kalu",
        },
        {
          id: 1000,
          employeeName: "Ahmed",
          status: "Approved",
          leaveType: "Maternity",
          startDate: "10-12-2019",
          endDate: "10-12-2019",
          relief: "Nonso Kalu",
        },
      ],
    };
  },
  computed: {
    showDeleteButton() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    toggleView() {
      this.view = !this.view;
    },
    handleViewDetails() {
      this.toggleView();
    },
    toggleShowForm() {
      this.showForm = !this.showForm;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>
